import { Impresa } from "./impresa.model";
import { ListinoNazionale } from "./listinoNazionale.model";

export class Listino {
  id: Number;
  azienda: Impresa;
  listinoNazionale:ListinoNazionale;

 /*  italia1: number;
  italia2: number;
  italia3: number;
  italia4: number;
  italia5: number; */

  liguria1: number;
  liguria2: number;
  liguria3: number;
  liguria4: number;
  liguria5: number;

  piemonte1: number;
  piemonte2: number;
  piemonte3: number;
  piemonte4: number;
  piemonte5: number;

  sardegna1: number;
  sardegna2: number;
  sardegna3: number;
  sardegna4: number;
  sardegna5: number;

  preventivoBaseItalia: number;
  preventivoBaseLiguria: number;
  preventivoBasePiemonte: number;
  preventivoBaseSardegna: number;

  creato: Date;
  modificato: Date;
  eliminato: Date;
   
  }
  